import { config } from "@config/config";
import { BlogCarouselSection } from "@shared/components/blog/blog-carousel-section";
import { CollaborateSection } from "@shared/components/collaborate-section/collaborate-section";
import { Helmet } from "@shared/components/helmet/helmet";
import { NavBar } from "@shared/components/navbar/navbar";
import { MartinVikStoryPage } from "@shared/components/story/pages/martin-vik/martin-vik";
import { useLocale } from "@translations/locale-context";
import { Footer } from "@ui/components/footer/footer";
import { NextPage } from "next";
import { useTranslation } from "next-i18next";
import React from "react";

export const Page: NextPage = () => {
    const locale = useLocale();
    const { t } = useTranslation();
    const isEn = locale === "en";

    return (
        <>
            <Helmet
                canonicalUrl={
                    config.FRONTEND_URL + (isEn ? "/en/blog/story/martin-vik" : "/blog/medailonek/martin-vik")
                }
                title={t("helmet.blog.story.martinVik.title")}
                metaTagData={{
                    metaDescription: t("helmet.blog.story.description"),
                    metaTitle: t("helmet.blog.story.martinVik.title"),
                }}
            />
            <NavBar />
            <MartinVikStoryPage />
            <BlogCarouselSection title={t("blog.otherArticles")} skipArticleByKey="martin-vik" />
            <CollaborateSection />
            <Footer />
        </>
    );
};
